export default __webpack_public_path__ + "static/media/blog-12.4185e60c.jpg";